import { render } from "./ReporteSolicitudesIncompletas.vue?vue&type=template&id=2b806e34&scoped=true"
import script from "./ReporteSolicitudesIncompletas.vue?vue&type=script&lang=js"
export * from "./ReporteSolicitudesIncompletas.vue?vue&type=script&lang=js"

import "./ReporteSolicitudesIncompletas.vue?vue&type=style&index=0&id=2b806e34&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b806e34"]])

export default __exports__